import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Alert } from 'react-bootstrap';
import { INikkeCharacterNode } from '../../../common/model/graphql-types';
import { NikkeElement } from './nikke-element';
import { NikkeType } from './nikke-type';
import { NikkeWeapon } from './nikke-weapon';
import { NikkeFaction } from './nikke-faction';
import { NIKKECharacterRatings } from '../../data/character-ratings';
import { NikkePopoverRatings } from './nikke-popover-ratings';

interface IProps {
  character: INikkeCharacterNode;
  tierID?: number;
}

export const NikkeCharacterPopover: React.FC<IProps> = ({
  character,
  tierID
}) => {
  const image = character.smallImage
    ? getImage(character.smallImage.localFile.childImageSharp)
    : null;
  const charInfo = NIKKECharacterRatings.find((char) =>
    tierID ? char.ID === tierID : char.Slug === character.slug
  );
  return (
    <div className="character-popover nikke">
      <div className="top">
        <div
          className={`avatar nikke-icon rarity-${character.rarity} ${
            character.hasTreasure ? 'has-treasure' : ''
          }`}
        >
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${character.name}`}
            />
          )}
        </div>
        <p className="name">
          <span className="emp-name">{character.name}</span>{' '}
          {character.isNew && <span className="tag new">NEW!</span>}{' '}
        </p>
        <div className="type-class">
          {character.element != 'Unknown' ? (
            <NikkeElement element={character.element} />
          ) : (
            ''
          )}
          {character.weapon != 'Unknown' ? (
            <NikkeWeapon weapon={character.weapon} />
          ) : (
            ''
          )}
          <NikkeFaction type={character.manufacturer} />
          {character.slug === 'red-hood' ? (
            <>
              <NikkeType type="red" />
            </>
          ) : (
            <>
              {character.skills.map((skill, index) => {
                return (
                  <span key={index}>
                    {skill.slot === 'Burst' && (
                      <NikkeType
                        type={character.burstType}
                        cooldown={skill.cooldown}
                        withcooldown
                      />
                    )}
                  </span>
                );
              })}
            </>
          )}
        </div>
      </div>
      {!character.isReviewPending ? (
        <>
          <NikkePopoverRatings character={charInfo} />
        </>
      ) : (
        <Alert variant="primary">
          <p>
            This character was recently released and we need time to properly
            test her abilities before reviewing and rating her.
          </p>
        </Alert>
      )}
    </div>
  );
};
